import { getSecureValue } from '@helpers';
import { trackEvent } from './trackEvent';
import { getTrackingInstance } from './initTracking';
import { TRACKING_EVENTS } from '@services/tracking/config';

export const trackUserLoggedOut = (): void => {
  const sessionStartTime = Number(getSecureValue('sessionStartTime'));
  const sessionDurationMinutes = sessionStartTime ? Math.round((Date.now() - sessionStartTime) / 60000) : 0;

  trackEvent(TRACKING_EVENTS.USER_LOGGED_OUT, {
    sessionDurationMinutes,
  });

  // Flush the logout event with the current user ID, then reset identity
  const instance = getTrackingInstance();
  if (instance) {
    instance.flush();
    instance.reset();
  }
};
